export default "__VITE_ASSET__602b8e01__"